import { createSelector } from '@ngrx/store';
import { getMultipleOrderOnlineState } from '@ordersnproducts/modules/multiple-order-online/redux/reducers';

export const selectedOrderConfirmation = createSelector(getMultipleOrderOnlineState, state => state.orderConfirmation);
export const getGroupRequest = createSelector(selectedOrderConfirmation, state => state.groupOrderRequest);
export const getLoadingOrderConfirmation = createSelector(getMultipleOrderOnlineState, state => state.orderConfirmation.loading);
